(ns bec-core.cljs.subs
  (:require [re-frame.core :as rf]
            [bec-cljs-common.re-frame.subs]
            ;; [bec-core.cljs.connection :as connection]
            [bec-core.cljs.notification :as notification]
            [bec-core.cljs.service-worker :as sw]
            [bec-core.cljs.routes :as routes]
            [clojure.string :as s]
            [bec-cljs-common.utils.formatting :as fmt]
            [lambdaisland.uri :refer [query-string->map]]))

(rf/reg-sub :get-db
  (fn [db _]
    db))

(rf/reg-sub :local-storage
  (fn [db [_ k]]
    (if k
      (get-in db [:local-storage k] nil)
      (get db :local-storage))))

(rf/reg-sub :selected-view
  (fn [db _]
    (:selected-view db)))

(rf/reg-sub :active-view
  :<- [:selected-view]
  :<- [:bec-cljs-common.networking/initialized?]
  :<- [:login]
  (fn [[selected-view initialized? login] _]
    (cond
      (not initialized?)
      [:waiting]

      false #_(not (:logged-in? login))
      [:login (when (= (first selected-view) :login) (second selected-view))]

      :else
      selected-view)))

(rf/reg-sub :view
  (fn [db [_ view-key]]
    (get-in db [:view view-key] nil)))

(rf/reg-sub :display?
  (fn [db [_ view-key]]
    (get db view-key)))

(rf/reg-sub :uri-map
  (fn [_ [_ uri-key]]
    (if uri-key
      (get routes/uri-map uri-key)
      routes/uri-map)))

(rf/reg-sub :uri-search-query-map
  :<- [:uri-map]
  (fn [uri-map [_ query-key]]
    (let [query-map (query-string->map (:query uri-map))]
      (if query-key
        (get query-map query-key)
        query-map))))

;; (rf/reg-sub :connection-information
;;   (fn [_ [_ information-key]]
;;     (if information-key
;;       (get @connection/information information-key)
;;       @connection/information)))

(rf/reg-sub :notification-permission?
  (fn [_ _]
    (not (nil? @notification/permission))))

(rf/reg-sub :notification-persistent?
  (fn [_ _]
    (notification/persistent?)))

(rf/reg-sub :app-installable?
  (fn [_ _]
    (and @sw/deferred-prompt @sw/registration)))

(rf/reg-sub :service-worker-registered?
  (fn [_ _]
    (not (nil? @sw/registration))))

(rf/reg-sub :service-worker-messages
  (fn [_ _]
    @sw/messages))

(rf/reg-sub :login
  (fn [db [_ _]]
    (:login db)))

(rf/reg-sub :bec-core-server
  (fn [db [_ _]] (:bec-core-server db)))

(rf/reg-sub :shared-state
  :<- [:bec-core-server]
  (fn [bec-core-server [_ _]]
    (:shared-state bec-core-server)))

(rf/reg-sub :observed-state-presence
  :<- [:bec-core-server]
  (fn [bec-core-server [_ machine-id]]
    (if machine-id 
      (get (:observed-state-presence bec-core-server) machine-id)
      (:observed-state-presence bec-core-server))))

(rf/reg-sub :observed-state
  :<- [:bec-core-server]
  (fn [bec-core-server [_ _]]
    (:observed-state bec-core-server)))

(rf/reg-sub :observed-state-customer-service
  :<- [:observed-state]
  (fn [observed-state [_ machine-id]]
    (if machine-id
      (get-in observed-state [machine-id :bec-clj-common :customer-service])
      observed-state)))

(rf/reg-sub :observed-state-customer-service-active-count
  :<- [:observed-state]
  (fn [observed-state [_ _]]
    (count (filter #(= (get-in (second %) [:bec-clj-common :customer-service :state]) :active) observed-state))))

(rf/reg-sub :machines
  :<- [:observed-state]
  (fn [observed-state [ _]]
    observed-state))

(rf/reg-sub :countries
  :<- [:machines]
  (fn [machines [ _]]
    (group-by
     (fn [machine]
       (:id (:country (:information machine))))
     (vals machines))))

(rf/reg-sub :cities
  :<- [:machines]
  (fn [machines [ _]]
    (group-by
     (fn [machine]
       (:id (:city (:information machine))))
     (vals machines))))

(rf/reg-sub :venues
  :<- [:machines]
  (fn [machines [ _]]
    (group-by
     (fn [machine]
       (:id (:venue (:information machine))))
     (vals machines))))

(rf/reg-sub :country-search
  :<- [:keypad]
  :<- [:countries]
  (fn [[keypad countries] [_ _]]
    (let [search (fmt/lower-case (:input (get keypad "country-search-bar-input")))]
      (if (and search (not (= search "")))
        (filter
         #(s/includes?
           (fmt/lower-case
            (str (:country-id (:information %))
                 (:id (:information %))
                 (:address (:information %))
                 (:revenue-type (:information %))))
           search)
         (vals countries))
        (vals countries)))))

(rf/reg-sub :city-search
  :<- [:keypad]
  :<- [:city]
  (fn [[keypad city] [_ _]]
    (let [search (fmt/lower-case (:input (get keypad "city-search-bar-input")))]
      (if (and search (not (= search "")))
        (filter
         #(s/includes?
           (fmt/lower-case
            (str (:country-id (:information %))
                 (:id (:information %))
                 (:address (:information %))
                 (:revenue-type (:information %))))
           search)
         (vals city))
        (vals city)))))

(rf/reg-sub :venue-search
  :<- [:keypad]
  :<- [:venues]
  (fn [[keypad venues] [_ _]]
    (let [search (fmt/lower-case (:input (get keypad "venue-search-bar-input")))]
      (if (and search (not (= search "")))
        (filter
         #(s/includes?
           (fmt/lower-case
            (str (:id (:country (:information %)))
                 (:id (:city (:information %)))
                 (:name (:city (:information %)))
                 (:id (:venue (:information %)))
                 (:address (:venue (:information %)))
                 (:revenue-type (:machine (:information %)))))
           search)
         (vals venues))
        (vals venues)))))

(rf/reg-sub :machine-search
  :<- [:keypad]
  :<- [:machines]
  (fn [[keypad machines] [_ _]]
    (let [search (fmt/lower-case (:input (get keypad "machine-search-bar-input")))]
      (if (and search (not (= search "")))
        (filter
         #(s/includes?
           (fmt/lower-case
            (str 
              (:model (:config %))
              (:machine-id (:config %))
              (:app-category (:config %))
              (:time-zone (:config %))
              (:wg-ip (:config %))
              (:display-name (:config %))
              (:hostname (:config %))))
           search)
         (vals machines))
        (vals machines)))))
